import React from "react";
import { useTranslation } from "react-i18next";
import "./GCDescription.css";

function GCDescription() {
  const { t } = useTranslation();

  return (
    <section className="description-container">
      <h1>{t("mainDescription.part1")}</h1>
      <p>{t("mainDescription.part2")}</p>
      <p className="description-invite">{t("mainDescription.part3")}</p>
    </section>
  );
}

export default GCDescription;
